<template>
  <div class="loading-overlay-section">
    <div class="loading-overlay-section__body">
      <loading-overlay-progress-parts
        v-for="(progressItem, index) in progressList"
        :key="`progress${index}`"
        :progressItem="progressItem"
      />
    </div>
    <p v-if="cautionMessage" class="loading-overlay-section__caution">{{ cautionMessage }}</p>
    <div v-if="buttonLabel" class="loading-overlay-section__buttons">
      <button class="loading-overlay-section__button" @click="handleButtonClicked">
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onUnmounted } from '@vue/composition-api'
import StoreUtil from '@/store/StoreUtil'
import LoadingOverlayProgressParts from '@/components/sections/LoadingOverlay/parts/LoadingOverlayProgressParts.vue'

/**
 * 共通ローディングオーバーレイの進捗表示に使用するセクション
 */
export default defineComponent({
  name: 'LoadingOverlayProgressSection',
  components: {
    LoadingOverlayProgressParts,
  },
  setup() {
    const loadingOverLayStore = StoreUtil.useStore('LoadingOverlayProgressStore')

    // 進捗状況リスト
    const progressList = computed(() => loadingOverLayStore.state.progressList)
    // 注意メッセージ
    const cautionMessage = computed(() => loadingOverLayStore.state.cautionMessage)
    // ボタンのラベル
    const buttonLabel = computed(() => loadingOverLayStore.state.buttonLabel)

    onUnmounted(() => {
      loadingOverLayStore.clearLoadingOverLayData()
    })

    return {
      progressList,
      cautionMessage,
      buttonLabel,
      setPressedButton: loadingOverLayStore.setPressedButton,
    }
  },
  methods: {
    handleButtonClicked() {
      this.setPressedButton(true)
    },
  },
})
</script>

<style lang="scss">
.vld-overlay {
  backdrop-filter: blur(2px);
}

.vld-icon {
  display: flex;
  gap: 32px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>

<style lang="scss" scoped>
.loading-overlay-section {
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 320px;
  padding-right: 27px;
  padding-left: 27px;
  margin-right: auto;
  margin-left: auto;
  color: #000;
  letter-spacing: 0.02em;

  &__body {
    font-size: 12px;
    line-height: 1.67;
    text-align: center;
  }

  &__caution {
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    white-space: pre-line;
  }

  &__buttons {
    width: 100%;
    margin-top: 5px;
  }

  &__button {
    width: 100%;
    background-color: #ffffff;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    padding: 11px 0;
    font-size: 13px;
    font-weight: 500;
    color: #4e4e4e;
  }
}
</style>
